<template>
  <div>
    <data-list :payload="ccsheetObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>
    <v-dialog v-model="dialog" width="700" persistent>
      <form-template :references.sync="formReferences" :model="ccsheetForm" ref="ccsheetReference"></form-template>
    </v-dialog>
    <!-- Download Content for CCSHEET -->
    <table class="table table-bordered d-none" ref="load_report">
      <tbody>
        <tr align="center">
          <th></th>
          <th>{{ $t('message.warehouse.product') }}</th>
          <th>{{ $t('message.stock.location') }}</th>
          <th>{{ $t('message.product.unit') }}</th>
          <th class="text-right">{{ $t('message.ccsheet.onStock') }}</th>
          <th class="text-right">{{ $t('message.ccsheet.counted') }}</th>
        </tr>
        <tr v-for="element in reportObj.stocks" :key="element.id">
          <td width="20%">{{ element.productnumber }}</td>
          <td width="44%"><div style="min-height: 24px;">{{ element.productname }}</div> </td>
          <td width="8%">{{ element.locationname }}</td>
          <td width="6%">{{ element.productunit }}</td>
          <td width="9%" class="text-right">{{ element.onstock | replaceDotWithComma }}</td>
          <td width="13%" class="text-right">{{ element.counted | replaceDotWithComma }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import DataList from '../../../components/DataList.vue'
import FormTemplate from '../../../components/FormTemplate.vue'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      ccsheetObj: {
        isHeader: true,
        isHideAdd: true,
        selection: [],
        showSelect: false,
        list: [],
        isccsheet: true,
        loading: true,
        page: 1,
        editProp: 'createdon',
        addClickHandler: this.newCCSheetFormHandler,
        editURL: (item) => `/w_h/ccsheet/actions/${item.id}`,
        actionsList: [{
          click: (item) => item,
          icon: () => 'mdi-brightness-1',
          color: (item) => item.havingconflict ? '#fe7171ab' : '#4caf506b',
          is_show: (item) => !this.$formatter.isNullOrEmpty(item.havingconflict)
        }, {
          click: this.deleteSheet,
          icon: () => 'mdi-trash-can-outline',
          is_show: (item) => item.status === 'ongoing'
        }, {
          click: this.reportCCSheet,
          color: () => '#d33737',
          icon: () => 'mdi-file-download',
          is_show: () => true
        }, {
          click: (item) => this.exportCCSheetItems(item.id),
          icon: () => 'mdi-file-excel',
          color: () => 'green',
          is_show: () => true
        }, {
          click: this.sheetEdit,
          icon: () => 'mdi-plus-circle-outline',
          is_show: (item) => {
            let show = false
            if (item.status !== 'ongoing' || item.status !== 'recount' || item.status !== 'completed_and_adjusted') show = false
            if (((item.status === 'completed' || item.status === 'recount') && item.havingconflict) || item.status === 'counted') show = true
            return show
          }
        }]
      },
      ccsheetForm: {
        id: 0,
        isquickcount: false,
        typeid: 1
      },
      loading: false,
      dialog: false,
      total: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.CCSHEET_INDEX) ? this.$store.state.CCSHEET_INDEX : { sortBy: ['createdon'], itemsPerPage: 25, sortDesc: [false], search: '' },
      headersValues: ['createdon', 'status'],
      isReport: false,
      reportObj: {},
      listOfWarehouse: [],
      MODULE_URL: 'ccsheets'
    }
  },
  components: {
    DataList,
    FormTemplate
  },
  computed: {
    ...mapState(['CCSHEET_INDEX', 'FORM_TYPE', 'listOfProductGroups']),
    headers () {
      return [{
        text: this.$t('message.order.date'),
        value: 'createdon',
        width: '10%'
      }, {
        text: `${this.$t('message.layout.warehouse')}`,
        value: 'warehousename',
        width: '20%'
      }, {
        text: this.$t('message.layout.status'),
        value: 'status',
        width: '20%'
      }, {
        text: this.$t('message.common.total'),
        value: 'total',
        width: '12%'
      }, {
        text: this.$t('message.ccsheet.countedTotal'),
        value: 'total_counted',
        width: '12%'
      }, {
        text: this.$t('message.common.difference'),
        value: 'difference',
        width: '12%'
      }, {
        text: this.$t('message.tickets.actions'),
        value: 'actions',
        width: '15%'
      }]
    },
    formReferences () {
      return {
        title: this.$t('message.ccsheet.addCCSheet'),
        properties: [{
          model: 'warehouseid',
          type: this.FORM_TYPE.SELECT,
          rules: this.$_requiredValidation,
          items: this.listOfWarehouse,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.warehouse'),
          class: 'xs12'
        }, {
          model: 'isquickcount',
          type: this.FORM_TYPE.CHECKBOX,
          rules: [],
          click: this.clearProductGroups,
          label: this.$t('message.ccsheet.quickCount'),
          class: 'xs12'
        }, {
          model: 'productgroupids',
          type: this.FORM_TYPE.SELECT,
          rules: this.ccsheetForm.isquickcount ? [] : this.$_requiredValidation,
          items: this.listOfProductGroups,
          select_text: (x) => `${x.number ? x.number + ' - ' : ''} ${x.name}`,
          select_value: 'id',
          disabled: !!this.ccsheetForm.isquickcount,
          multiple: true,
          label: this.$t('message.user.group'),
          class: 'xs12'
        }, {
          model: 'typeid',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          items: this.listOfCCSheetTypes,
          select_text: 'text',
          select_value: 'id',
          label: this.$t('message.ccsheet.itemsToCount'),
          class: 'xs12'
        }, {
          model: 'comments',
          type: this.FORM_TYPE.TEXTAREA,
          rules: [],
          label: this.$t('message.common.comments'),
          class: 'xs12'
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    },
    listOfCCSheetTypes () {
      return [{
        text: this.$t('message.ccsheet.all'),
        id: 1
      }, {
        text: this.$t('message.ccsheet.stockItems'),
        id: 2
      }, {
        text: this.$t('message.ccsheet.nonStockItems'),
        id: 3
      }]
    }
  },
  watch: {
    pagination (val) {
      let model = { type: 'CCSHEET_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
    }
  },
  mounted () {
    this.getCCSheetHandler()
    this.$store.dispatch('getProductGroups')
    // this.getWarehouse()
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.ccsheetObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getCCSheetHandler()
        // this.getWarehouse()
      }
    })
  },
  methods: {
    getWarehouse () {
      this.$_executeApi('get', `warehouses/get_warehouse_for_ccsheet_creation`).then(response => {
        this.listOfWarehouse = response.data
      })
    },
    getCCSheetHandler () {
      this.ccsheetObj.loading = true
      this.ccsheetObj.module = this.MODULE_URL
      this.$_executeApi('get', `${this.MODULE_URL}`)
        .then((response) => {
          this.ccsheetObj.loading = false
          let transformData = { number: { list: ['total', 'difference', 'total_counted'], format: 'replaceDotWithComma' }, date: { list: ['createdon'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' } }
          let model = this.$_formatListModel(response.data, transformData)
          var statusList = this.$_ccsheetStatus
          model.map(x => {
            x.createdon_date = x.createdon
            var statusObj = statusList.find(y => y.value === x.status)
            x.status_val = statusObj ? this.$t(statusObj.text) : ''
            x.warehousename = `${x.warehousename} (${this.$t(`message.warehouse.${x.type}`)})`
            return x
          })
          this.ccsheetObj.list = model
          this.total = response.data.total
          if (this.pagination.page > 1 && this.total <= this.pagination.itemsPerPage * (this.pagination.page - 1)) {
            this.pagination.page = 1
            this.ccsheetObj.page = 1
          }
        })
    },
    sheetEdit (item) {
      if (item.editcount < 2) this.$router.push(`/w_h/ccsheet/actions/${item.id}/true`)
      else this.$router.push(`/w_h/ccsheet/adjustment_order/${item.id}`)
    },
    deleteSheet (item) {
      let payload = { ids: [item.id], url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
      this.$store.commit('showDeleteDialog', payload)
    },
    newCCSheetFormHandler () {
      this.getWarehouse()
      this.dialog = true
      this.ccsheetForm.typeid = 1
      this.setDefaultValues({ prop: 'warehouseid', list: this.listOfWarehouse })
    },
    supportingList (type, text) {
      const modelName = text
      text = this.$refs.ccsheetReference.$refs[text][0].lazySearch
      let model = { module: type, dialog: true, text, modelName }
      this.$store.commit('supportingList', model)
    },
    clearProductGroups () {
      this.ccsheetForm.productgroupids = null
    },
    saveUpdateHandler () {
      if (this.$refs.ccsheetReference.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.$formatter.cloneVariable(this.ccsheetForm)
        let url = this.MODULE_URL
        this.isCCSheetExists()
          .then((response) => {
            if (!response.data) {
              if (model.productgroupids) model.productgroupids = JSON.stringify(model.productgroupids)
              this.$_saveUpdateHandler(url, model)
                .then((response) => {
                  this.closeDialogHandler()
                  this.getCCSheetHandler()
                })
                .finally(() => {
                  this.loading = false
                })
            } else {
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.ccsheet_warehouse_exists') })
              this.loading = false
            }
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    closeDialogHandler () {
      this.$refs.ccsheetReference.$refs.validateForm.reset()
      this.dialog = false
    },
    isCCSheetExists () {
      return this.$_executeApi('post', `${this.MODULE_URL}/having_incomplete_sheet/${this.ccsheetForm.warehouseid}`, this.ccsheetForm.productgroupids || [])
    },
    reportCCSheet (item) {
      this.ccsheetObj.loading = true
      this.$_executeApi('get', `/ccsheets/get_ccsheet/${item.id}`)
        .then((response) => {
          this.reportObj = response.data
          setTimeout(() => {
            this.downloadReport(this.reportObj.warehousename)
          }, 500)
        })
    },
    downloadReport (warehouse) {
      let filename = `${this.$t('message.ccsheet.ccsheetReport')}_${warehouse}_${this.$_getCurrentDate()}`
      let getBase64Content = { visiblefilename: filename, content: this.getPDFContent(), islandscape: false }
      this.$_executeApi('post', '/ccsheets/generate_pdf', getBase64Content)
        .then((response) => {
          let fileName = response.data
          window.open(`${process.env.VUE_APP_URL}file/download/?fileName=${fileName}`, '_blank')
        })
        .finally(() => {
          this.ccsheetObj.loading = false
        })
    },
    setDefaultValues (data) {
      let { list, prop } = data
      let item = list.find(x => x.isdefault)
      if (item) {
        let model = Object.assign({ ...this.ccsheetForm }, { [prop]: item.id })
        this.ccsheetForm = model
      }
    },
    getDiffTotal (item) {
      let total = 0
      if (item) {
        total = (item.onstock - item.counted) * item.salesprice
      }
      return total
    },
    getPDFContent () {
      let { warehousename, modifiedby, date, comments, stocks, productgroupnames, productgroupids } = this.reportObj
      date = this.$_filterDate(date)
      let styleLink = `<link href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" rel="stylesheet" />
        <style>
        svg {
          color: #5ebb47;
          width: 60%;
        }
        #text_green, #emblem {
          fill: currentcolor;
        }
        thead { display: table-header-group; }
        tfoot { display: table-row-group; }
        tr { page-break-inside: avoid;
        tbody tr td {text-align: justify;word-break: break-word;min-height: 100px;}

        </style>`
      let getHTMLContent = `<!DOCTYPE html><html><head><meta name="viewport" content="width=device-width" />
        <meta charset="utf-8"/>${styleLink}</head>
        <body>
        <div class="container">
          <div class="col-xs-6">
            <img class="img-responsive" height="100" width="100" src="https://kilabapi.apphouse.no/kilab_logo.png">
          </div>
          <div class="col-xs-6">
            <h3>${this.$t('message.ccsheet.ccsheetReport')}</h3>
          </div>
          <div class="clearfix"></div>
          <div class="col-xs-6">
            <label style="font-weight: bold;">${this.$t('message.layout.warehouse')}:</label> ${warehousename || ''}
          </div>
          <div class="col-xs-6">
            <label style="font-weight: bold;">${this.$t('message.common.completedBy')}:</label> ${modifiedby ? `${modifiedby.firstname || ''} ${modifiedby.lastname || ''}` : ''}
          </div>
          ${productgroupids ? `<div class="col-xs-6">
            <label style="font-weight: bold;">${this.$t('message.user.group')}</label>
            ${productgroupnames ? productgroupnames.join(', ') : ''}
          </div>` : ''}
          <div class="col-xs-6">
            <label style="font-weight: bold;">${this.$t('message.common.completedAt')}:   </label> ${date || ''}
          </div>
          <div class="col-xs-6">
            <label style="font-weight: bold;">${this.$t('message.ccsheet.totalValues')}</label> <label style="text-transform:lowercase"> ${this.$t('message.ccsheet.counted')}:</label> ${this.getTotalSum(stocks)}
          </div>
          <div class="clearfix"></div>
          <div class="col-xs-6">
            <label style="font-weight: bold;">${this.$t('message.common.comments')}:</label> ${comments || ''}
          </div>
          <div class="clearfix"></div>
          ${this.$refs.load_report.outerHTML}
        </div>
        </body></html>`
      return btoa(unescape(encodeURIComponent(getHTMLContent)))
    },
    getTotalSum (stocks) {
      let total = 0
      if (stocks && stocks.length > 0) {
        stocks.map(x => {
          total += (x.counted * x.salesprice)
        })
      }
      return this.$formatter.replaceDotWithComma(total)
    },
    exportCCSheetItems (id) {
      this.ccsheetObj.loading = true
      this.$_executeApi('post', `ccsheetitems/export?id=${id}`).then(response => {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.exportedSuccess') })
        window.open(`${process.env.VUE_APP_URL}file/download/?fileName=${response.data}`, '_blank')
      }).finally(() => {
        this.ccsheetObj.loading = false
      })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
